import React from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from '@ddc/classnames-js';

const ReviewHeader = ({ 
	review, 
	reviewHeadingWeight, 
	reviewHeadingCase, 
	reviewRatingFontSize, 
	circleRatingBgColor,
	textColor, 
	textMutedColor,
	className = 'kbb-review-item flex-grow-1 d-flex align-items-center mb-21 pl-1'
}) => {
	const circleRatingClasses = [
		circleRatingBgColor,
		'p-4',
		'kbb-review-rating',
		'font-weight-bold',
		'rounded-circle',
		reviewRatingFontSize,
		'mr-4',
		textColor
	];

	return (
		<div className={className}>
			<strong className={setClassNames(circleRatingClasses)}>
				{review.overallRating && parseFloat(review.overallRating).toFixed(1)}
			</strong>
			<div className="kbb-review-heading-container">
				{review.title && (
					<h3
						className={`kbb-review-heading ${reviewHeadingWeight} ${reviewHeadingCase} m-0 ${textColor} h4`}
					>
						{review.title}
					</h3>
				)}
				<p className={`${textMutedColor} mb-0 ddc-font-size-xsmall`}>
					{review.nickName && (
						<span>
							<span className="kbb-review-name">
								by {review.nickName}
							</span>
							<span
								className="separator"
								aria-hidden="true"
							>
								&nbsp;|&nbsp;
							</span>
							<span className="sr-only">
								{' '}
								on{' '}
							</span>
						</span>
					)}

					<span className="kbb-review-submission-date">
						{review.submissionDate}
					</span>
				</p>
			</div>
		</div>
	);
};

ReviewHeader.propTypes = {
	review: PropTypes.shape({
		overallRating: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		title: PropTypes.string,
		nickName: PropTypes.string,
		submissionDate: PropTypes.string
	}).isRequired,
	reviewHeadingWeight: PropTypes.string,
	reviewHeadingCase: PropTypes.string,
	reviewRatingFontSize: PropTypes.string,
	circleRatingBgColor: PropTypes.string,
	textColor: PropTypes.string,
	textMutedColor: PropTypes.string,
	className: PropTypes.string
};

ReviewHeader.defaultProps = {
	reviewHeadingWeight: 'font-weight-bold',
	reviewHeadingCase: 'text-capitalize',
	reviewRatingFontSize: 'ddc-font-size-large',
	circleRatingBgColor: 'bg-primary',
	textColor: '',
	textMutedColor: 'text-muted'
};

export default ReviewHeader;
